import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78e3daf0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "alerts-widget"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bell-fill" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "alerts-widget__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chevron-right alerts-widget__chevron" }, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "alerts-widget__footer"
}

import { computed, ref, watch } from 'vue';
import DashboardWidget from '@/components/dashboard/DashboardWidget.vue';
import { useDashboardQuery } from '@/core/hooks/useDashboardQuery';
import { useDashboardStore } from '@/core/hooks/useDashboardStore';
import { DashboardService } from '@/core/services/Dashboard.service';
import {
  DASHBOARD_ALERT_SEVERITY_STYLES,
  formatAlertListLabel,
} from '@/core/constants/dashboard.constants';
import { getDashboardLinkProps, hasDashboardRoute } from '@/core/helpers/resolve-dashboard-route';
import type {
  DashboardAlertItem,
  DashboardAlertsData,
} from '@/core/interfaces/Dashboard';

const previewLimit = 4;


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsWidget',
  props: {
    compact: { type: Boolean }
  },
  setup(__props: any) {



const { scope } = useDashboardStore();
const showAll = ref(false);
const alertLimit = computed(() => (showAll.value ? 20 : previewLimit));

watch(scope, () => {
  showAll.value = false;
});

const {
  data,
  isFetching,
  isError,
  isEmpty,
  isStale,
  generatedAt,
  refetch,
} = useDashboardQuery<DashboardAlertsData>(
  'alerts',
  scope,
  (s) =>
    DashboardService.getAlerts(s, {
      limit: alertLimit.value,
    }),
  { filters: computed(() => ({ limit: alertLimit.value, show_all: showAll.value })) }
);

const visibleItems = computed(() => data.value?.items ?? []);

const hasMore = computed(
  () => !showAll.value && (data.value?.items?.length ?? 0) >= previewLimit
);

function severityStyle(severity: string): Record<string, string> {
  const style =
    DASHBOARD_ALERT_SEVERITY_STYLES[severity] ??
    DASHBOARD_ALERT_SEVERITY_STYLES.info;
  return {
    backgroundColor: style.bg,
    color: style.tone,
  };
}

function routeProps(item: DashboardAlertItem): Record<string, unknown> {
  return getDashboardLinkProps(item.route);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardWidget, {
    title: "Cảnh báo cần chú ý",
    compact: _ctx.compact,
    loading: _unref(isFetching),
    error: _unref(isError),
    empty: _unref(isEmpty),
    "is-stale": _unref(isStale),
    "generated-at": _unref(generatedAt),
    "has-cached-content": Boolean(_unref(data)),
    "empty-text": "Không có cảnh báo cần xử lý.",
    onRetry: _unref(refetch)
  }, {
    default: _withCtx(() => [
      (visibleItems.value.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.key,
                class: "alerts-widget__item"
              }, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(hasDashboardRoute)(item.route) ? 'router-link' : 'div'), _mergeProps(routeProps(item), { class: "alerts-widget__link" }), {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "alerts-widget__icon",
                      style: _normalizeStyle(severityStyle(item.severity))
                    }, _hoisted_3, 4),
                    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatAlertListLabel)(item.count, item.label)), 1),
                    _hoisted_5
                  ]),
                  _: 2
                }, 1040))
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (hasMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "alerts-widget__more",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showAll.value = true))
            }, " Xem tất cả > ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["compact", "loading", "error", "empty", "is-stale", "generated-at", "has-cached-content", "onRetry"]))
}
}

})